import { render, staticRenderFns } from "./paymch.vue?vue&type=template&id=4948422e&scoped=true"
import script from "./paymch.vue?vue&type=script&lang=js"
export * from "./paymch.vue?vue&type=script&lang=js"
import style0 from "./paymch.vue?vue&type=style&index=0&id=4948422e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4948422e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4948422e')) {
      api.createRecord('4948422e', component.options)
    } else {
      api.reload('4948422e', component.options)
    }
    module.hot.accept("./paymch.vue?vue&type=template&id=4948422e&scoped=true", function () {
      api.rerender('4948422e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wx/paymch.vue"
export default component.exports